import { OrderStatusType } from 'api/types/entity/order/orderStatusType';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  string,
  selectSchema,
  date,
} from 'libs/form';
import { SelectType } from 'types/selectType';

import { OrderAvailableStatusesMap } from '../types';

export interface ChangeStatusFormType {
  reason?: string;
  fmNumber?: string;
  closedDate?: Date;
  status: SelectType<OrderStatusType>;
}

export interface ChangeStatusFormSchemaProps {
  availableStatusesMap: Partial<OrderAvailableStatusesMap>;
}

export const getSchema = ({
  availableStatusesMap,
}: ChangeStatusFormSchemaProps): ObjectSchema<ChangeStatusFormType> =>
  object({
    status: selectSchema(Object.values(OrderStatusType))
      .required()
      .default(null),

    reason: string().when('status', {
      is: (s: SelectType<OrderStatusType>) =>
        availableStatusesMap[s?.value]?.isRequiredReason,
      then: (schema) => schema.required().max(200),
    }),

    fmNumber: string().when('status', {
      is: (s: SelectType<OrderStatusType>) =>
        availableStatusesMap[s?.value]?.isRequiredFmNumber,
      then: (schema) => schema.required().max(50),
    }),

    closedDate: date().when('status', {
      is: (s: SelectType<OrderStatusType>) =>
        availableStatusesMap[s?.value]?.isRequiredClosedDate,
      then: (schema) => schema.required().max(new Date()),
    }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<ChangeStatusFormType>();

export type FormErrors = FormErrorsBase<ChangeStatusFormType>;
